/* eslint-disable react/no-unescaped-entities */
import { Meta } from '@/layout/Meta'
import { Main } from '@/templates/Main'
import { Code } from '@/utils/Code'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { note } from '@/utils/Note'
import BlogCta from './blog-cta'

const CjLink = (props: {path: string, children: string}) => {
  const relativePath = props.path.replace(/^\//, '') // strip leading slash if it exists
  const linkText = props.children
  return (
    <Link href={`https://developers.cj.com/${relativePath}`}>
      { linkText }
    </Link>
  )
}

const HowToIntegrateWithCjPublisher= () => {
  const router = useRouter()

  useEffect(() => {
    note('Visited CJ tutorial')
  }, [])
  
  return (
    <Main meta={<Meta 
        title="How to Integrate with CJ Publisher"
        description="Connecting to Commission Junction Publisher API" />}>
      <h1 className="text-4xl font-bold text-sky-700">Commission Junction</h1>
      <h2>Publisher API</h2>
      <BlogCta />
      <div>
        <h2 className="text-4xl font-bold text-sky-700">Overview</h2>
        <CjLink path="/graphql/reference/Commission%20Detail">Commission Junction</CjLink> provides
        incredibly robust and developer friendly APIs.
      </div>
      <div>
        The steps are:
        <ol className="list-decimal list-inside">
          <li>Create a personal access token</li>
          <li>Identify your publisher (or advertiser) id</li>
          <li>Query the API</li>
        </ol>
      </div>
      <div>
        <h2 className="text-4xl font-bold text-sky-700">Create a personal access token</h2>
        Go to <CjLink path="/account/personal-access-tokens">Personal Access Tokens</CjLink> and create a new token.  Make
        sure to note the created token.
      </div>
      <div>
        <h2 className="text-4xl font-bold text-sky-700">Identify your publisher ID</h2>
        Simply log into your dashboard at <Link href="https://members.cj.com/member/publisher/home.do">CJ.com</Link> and look at the URL, and find your ID located
        in your account drop down

        <img src={`${router.basePath}/assets/images/cj-cid.png`} alt="CJ Business ID" />
      </div>
      <div>
        <h2 className="text-4xl font-bold text-sky-700">Query the API</h2>
        Query the publisher API using standard GraphQL syntax.  The biggest recommendation for Typescript users
        is to make sure you're not injecting unsupported newlines.  The easiest thing is to you copy your query onto
        a single line.
      </div>
      <div>
        <h2 className="text-4xl font-bold text-sky-700">cURL example</h2>
        <Code>{`
        curl --location 'https://commissions.api.cj.com/query' \ 
          --header 'Content-Type: application/json' \ 
          --header 'Authorization: Bearer \${personal access token}' \ 
          --data '{
            "query":"{ 
              publisherCommissions(
                forPublishers: [\"\${publisherId}\"], 
                sincePostingDate:\"2023-03-01T00:00:00Z\",
                beforePostingDate:\"2023-03-21T00:00:00Z\")
                {count payloadComplete records 
                      {actionTrackerName 
                      websiteName 
                      advertiserName 
                      postingDate 
                      pubCommissionAmountUsd 
                      orderId 
                      shopperId 
                      publisherName 
                      websiteName 
                      items { 
                          quantity 
                          perItemSaleAmountPubCurrency 
                          totalCommissionPubCurrency 
                      }
                    }
                }
            }"
            ,"variables":{}}
        `}</Code>
      </div>
    </Main>
  )
}

export default HowToIntegrateWithCjPublisher
